/*处理表格的分页、和序号问题*/
export const indexAndPage = {
  data(){
    return {
      pageNum:[20,40,60,80,150,200,500],// 每页可以显示的条数范围切换
      comPageSize:40,// 每页显示条数
    }
  },
  mounted(){

  },
  methods:{
    // 计算每页的序号
    getPageIndex(index,currentPage,pageSize){// currentPage 当前页码 pageSize 每页显示多少条
      return (index + 1) + (currentPage - 1) * pageSize
    },
     isArray(arr){
        return Object.prototype.toString.call(arr)==='[object Array]';
      },
    //图片预览需要token
    viewerImageByToken(urlList,index){
      let vm = this,fileList=[],image=false,baseUrl = vm.api.file.preview +'/file/spreview/';
      if (localStorage.getItem('viewImageUrl')) {
        localStorage.removeItem("viewImageUrl");
      }
      index = this.$Util.isEmpty(index)  ? 0 :index;
      /*有其他文件格式事，index索引不对*/
      let currentImgIndexUid = urlList[index].fileId;
      /*image*/
      let fileFormat = vm.isArray(urlList) && urlList.length > 0 ? urlList[index].name.split(".") : urlList.split("."),
        fileLen = fileFormat.length-1;
      if(fileFormat[fileLen] == 'jpg' || fileFormat[fileLen] == 'png'|| fileFormat[fileLen] == 'jpeg') {
        image = true;
        if (vm.isArray(urlList) && urlList.length > 0) {
          urlList.forEach((item, i) => {
            let itemFileFormat = item.name.split("."), itemFileLen = itemFileFormat.length - 1;
            if (itemFileFormat[itemFileLen] == 'jpg' || itemFileFormat[itemFileLen] == 'png'|| fileFormat[fileLen] == 'jpeg') {
              fileList.push({filePath:baseUrl+ item.filePath+'?access_token='+localStorage.getItem('token'), deg: 0,fileId:item.fileId})
            }
          })
        } else {
          fileList.push({filePath:baseUrl+ urlList+'?access_token='+localStorage.getItem('token'), deg: 0})
        }
      }
      //判断当前点击的是不是png/jpg
      if(image){
        /*判断索引*/
        let currentIndex = fileList.indexOf(fileList.filter(d=>d.fileId == currentImgIndexUid)[0]);
        /*判断索引end*/
        let param = { urlList:fileList,index:currentIndex }
        localStorage.setItem("viewImageUrl", JSON.stringify(param));
        let routeUrl = this.$router.resolve({  path: "/imageView", query: {} });
        window.open(routeUrl.href, '_blank');
      }else{
        let url = vm.isArray(urlList) && urlList.length > 0 ? baseUrl+urlList[index].filePath+'?access_token='+localStorage.getItem('token') : baseUrl+urlList+'?access_token='+localStorage.getItem('token') ;
        window.open(url, "_blank");
      }
    },
    /*el-upload 预览*/
    handleUploadPreviewImgByToken(list,file) {
      for(let i = 0;i<list.length;i++) {
        let one = list[i];
        if (one.name == file.name){
          this.viewerImageByToken(list,i)
          /*window.open(one.url , "_blank");*/
        }
      }
    },
    //不需要token预览
    viewerImage(urlList,index){
      let vm = this,fileList=[],image=false,baseUrl = vm.api.file.preview +'/file/preview?filePath=';
      if (localStorage.getItem('viewImageUrl')) {
        localStorage.removeItem("viewImageUrl");
      }
      index = this.$Util.isEmpty(index)  ? 0 : index;
      /*有其他文件格式事，index索引不对*/
      let currentImgIndexUid = urlList[index].uid;
      /*image*/
      let fileFormat = vm.isArray(urlList) && urlList.length > 0 ? urlList[index].name.split(".") : urlList.split("."),
        fileLen = fileFormat.length-1;
      if(fileFormat[fileLen] == 'jpg' || fileFormat[fileLen] == 'png'|| fileFormat[fileLen] == 'jpeg') {
        image = true;
        if (vm.isArray(urlList) && urlList.length > 0) {
          urlList.forEach((item, i) => {
            let itemFileFormat = item.name.split("."), itemFileLen = itemFileFormat.length - 1;
            if (itemFileFormat[itemFileLen] == 'jpg' || itemFileFormat[itemFileLen] == 'png'|| fileFormat[fileLen] == 'jpeg') {
              fileList.push({filePath:baseUrl+ item.filePath, deg: 0,uid:item.uid});
            }
          })
        } else {
          fileList.push({filePath:baseUrl+ urlList, deg: 0})
        }
      }
      //判断当前点击的是不是png/jpg
      if(image){
        /*判断索引*/
        let currentIndex = fileList.indexOf(fileList.filter(d=>d.uid == currentImgIndexUid)[0]);
        /*判断索引end*/
        let param = { urlList:fileList,index:currentIndex }
        localStorage.setItem("viewImageUrl", JSON.stringify(param));
        let routeUrl = this.$router.resolve({  path: "/imageView", query: {} });
        window.open(routeUrl.href, '_blank');
      }else{
        let url = vm.isArray(urlList) && urlList.length > 0 ? baseUrl+urlList[index].filePath : baseUrl+urlList ;
        window.open(url, "_blank");
      }
    },
    /*el-upload 预览*/
    handleUploadPreviewImg(list,file) {
      for(let i = 0;i<list.length;i++) {
        let one = list[i];
        if (one.name == file.name){
          this.viewerImage(list,i)
          /*window.open(one.url , "_blank");*/
        }
      }
    },
    /*详情 预览*/
    handleDetailPreviewImg(list,index ) {
      let vm = this;
      index = vm.$Util.isEmpty(index)  ? 0 :index;
      vm.viewerImage(list,index)
    },
    /*详情 预览需要token*/
    handleDetailPreviewImgByToken(list,index ) {
      let vm = this;
      index = vm.$Util.isEmpty(index)  ? 0 :index;
      vm.viewerImageByToken(list,index)
    },

  }
}



// WEBPACK FOOTER //
// ./src/publicMethods/mixins.js